import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ModalModule} from 'ngx-bootstrap/modal';
import {ImageCaptureComponent} from './image-capture/image-capture.component';
import {DeviceDetectorService} from 'ngx-device-detector';
import {ImageCaptureCreateCardComponent} from './image-capture-create-lead/image-capture-create-card.component';
import {ProcessingLoaderComponent} from './processing-loader/processing-loader.component';
import {CardScannerService} from './card-scanner.service';
import { ErrorStateComponent } from './error-state/error-state.component';

@NgModule({
    imports: [
        CommonModule,
        ModalModule
    ],
    declarations: [
        ImageCaptureComponent,
        ImageCaptureCreateCardComponent,
        ProcessingLoaderComponent,
        ErrorStateComponent
    ],
    exports: [
        ImageCaptureComponent,
        ImageCaptureCreateCardComponent,
        ProcessingLoaderComponent
    ],
    providers: [
        DeviceDetectorService,
        CardScannerService
    ]
})

export class CardScannerModule {}
